import { render, staticRenderFns } from "./ShareCampaigns.vue?vue&type=template&id=8f0e5edc&scoped=true"
import script from "./ShareCampaigns.vue?vue&type=script&lang=js"
export * from "./ShareCampaigns.vue?vue&type=script&lang=js"
import style0 from "./ShareCampaigns.vue?vue&type=style&index=0&id=8f0e5edc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0e5edc",
  null
  
)

export default component.exports